import React from 'react';
export function Footer() {
  return <footer className="bg-navy-800 text-white pt-20 pb-10 border-t-4 border-gold-500" data-id="element-22">
      <div className="max-w-7xl mx-auto px-6" data-id="element-23">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-24">
          {/* Brand Column */}
          <div className="lg:col-span-1" data-id="element-25">
            <a href="#" className="text-2xl font-heading text-gold-500 tracking-tight mb-6 block" data-id="element-26">
              Goldspeakers
            </a>
            <p className="text-gray-400 text-sm leading-relaxed mb-6" data-id="element-27">
              Trusted Voices for Real Change. We connect organisations with
              speakers who deliver measurable impact.
            </p>
            <p className="text-white font-medium text-sm" data-id="element-28">
              Curated. Strategic. Safe to book.
            </p>
          </div>

          {/* Company Links */}
          <div data-id="element-29">
            <h4 className="text-lg font-bold mb-6 text-white" data-id="element-30">Company</h4>
            <ul className="space-y-3" data-id="element-31">
              {['Home', 'About Us', 'Speakers Directory', 'Speakers Details', 'Booking', 'Blog'].map(item => <li key={item} data-id="element-32">
                  <a href="#" className="text-gray-400 hover:text-gold-400 transition-colors text-sm" data-id="element-33">
                    {item}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Legal Links */}
          <div data-id="element-34">
            <h4 className="text-lg font-bold mb-6 text-white" data-id="element-35">Legal</h4>
            <ul className="space-y-3" data-id="element-36">
              {['Terms of Use', 'Privacy Policy', 'Cookie Policy'].map(item => <li key={item} data-id="element-37">
                    <a href="#" className="text-gray-400 hover:text-gold-400 transition-colors text-sm" data-id="element-38">
                      {item}
                    </a>
                  </li>)}
            </ul>
          </div>

          {/* Follow Us */}
          <div data-id="element-39">
            <h4 className="text-lg font-bold mb-6 text-white" data-id="element-40">Follow Us</h4>
            <p className="text-gray-400 text-sm mb-4" data-id="element-41">
              Stay updated with our latest speakers and insights.
            </p>
            <div className="flex space-x-3" data-id="element-42">
              {/* LinkedIn */}
              <a href="#" className="w-11 h-11 bg-petrol-600 rounded-full hover:bg-gold-500 transition-colors cursor-pointer flex items-center justify-center group" data-id="element-43">
                <span className="sr-only" data-id="element-44">LinkedIn</span>
                <svg className="w-5 h-5 fill-current text-cream-100 group-hover:text-white transition-colors" viewBox="0 0 24 24" data-id="element-45">
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" data-id="element-46" />
                </svg>
              </a>
              {/* Instagram */}
              <a href="#" className="w-11 h-11 bg-petrol-600 rounded-full hover:bg-gold-500 transition-colors cursor-pointer flex items-center justify-center group" data-id="element-47">
                <span className="sr-only" data-id="element-48">Instagram</span>
                <svg className="w-5 h-5 fill-current text-cream-100 group-hover:text-white transition-colors" viewBox="0 0 24 24" data-id="element-49">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" data-id="element-50" />
                </svg>
              </a>
              {/* Facebook */}
              <a href="#" className="w-11 h-11 bg-petrol-600 rounded-full hover:bg-gold-500 transition-colors cursor-pointer flex items-center justify-center group" data-id="element-51">
                <span className="sr-only" data-id="element-52">Facebook</span>
                <svg className="w-5 h-5 fill-current text-cream-100 group-hover:text-white transition-colors" viewBox="0 0 24 24" data-id="element-53">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385h-3.047v-3.47h3.047v-2.642c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953h-1.514c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385c5.738-.9 10.126-5.864 10.126-11.854z" data-id="element-54" />
                </svg>
              </a>
              {/* X / Twitter */}
              <a href="#" className="w-11 h-11 bg-petrol-600 rounded-full hover:bg-gold-500 transition-colors cursor-pointer flex items-center justify-center group" data-id="element-55">
                <span className="sr-only" data-id="element-56">X</span>
                <svg className="w-4 h-4 fill-current text-cream-100 group-hover:text-white transition-colors" viewBox="0 0 24 24" data-id="element-57">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" data-id="element-58" />
                </svg>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 text-center" data-id="element-59">
          <p className="text-gray-500 text-sm" data-id="element-60">
            © {new Date().getFullYear()} Goldspeakers. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}